import styled, { css } from 'styled-components'

import { themeVariablesCss } from '@root/shared/ui-kit/theme'

import type { Theme as DelugeTheme } from '@blade/ui-theme'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  theme: DelugeTheme
  dashed?: boolean
} & ClassNameProps

export const ThemePreview = (props: Props) => {
  const { theme, className, dashed = false } = props

  const cssVariables = themeVariablesCss(theme)

  return (
    <Root css={cssVariables} className={className}>
      <Inner>
        <Card
          css={css`
            background: var(--background-1);
            border: 1px solid var(--background-2);
          `}
        >
          <Header>
            <Left>
              <Primary
                css={
                  dashed
                    ? css`
                        border: 1px dashed var(--primary-9);
                      `
                    : css`
                        background: var(--primary-9);
                      `
                }
              />
            </Left>
            <Center>
              <FirstRow>
                <Text
                  css={css`
                    background: var(--text-12);
                  `}
                />
                <Text
                  css={css`
                    background: var(--text-11);
                  `}
                />
                <Text
                  css={css`
                    background: var(--text-9);
                  `}
                />
                <Text
                  css={css`
                    background: var(--text-6);
                  `}
                />
              </FirstRow>
              <SecondRow>
                <Text
                  css={css`
                    background: var(--warning-9);
                  `}
                />
                <Text
                  css={css`
                    background: var(--success-10);
                  `}
                />
                <Text
                  css={css`
                    background: var(--error-10);
                  `}
                />
              </SecondRow>
            </Center>
            <Right>
              <RightRow>
                <Text
                  css={
                    dashed
                      ? css`
                          border: 1px dashed var(--up-9);
                        `
                      : css`
                          background: var(--up-9);
                        `
                  }
                />
              </RightRow>
              <RightRow>
                <Text
                  css={
                    dashed
                      ? css`
                          border: 1px dashed var(--down-9);
                        `
                      : css`
                          background: var(--down-9);
                        `
                  }
                />
              </RightRow>
            </Right>
          </Header>
          <Separator
            css={css`
              background: var(--background-2);
            `}
          />
          <Body>
            <Skeleton
              css={
                dashed
                  ? css`
                      border: 1px dashed var(--background-5);
                    `
                  : css`
                      background: var(--background-5);
                    `
              }
            />
            <Skeleton
              css={
                dashed
                  ? css`
                      border: 1px dashed var(--background-5);
                    `
                  : css`
                      background: var(--background-5);
                    `
              }
            />
            <Skeleton
              css={
                dashed
                  ? css`
                      border: 1px dashed var(--background-5);
                    `
                  : css`
                      background: var(--background-5);
                    `
              }
            />
            <Skeleton
              css={
                dashed
                  ? css`
                      border: 1px dashed var(--background-5);
                    `
                  : css`
                      background: var(--background-5);
                    `
              }
            />
          </Body>
        </Card>
      </Inner>
    </Root>
  )
}

const Root = styled.div``
const Inner = styled.div`
  background: var(--appearance-1);
  padding: 12px;
`

const Card = styled.div`
  border-radius: 6px;
`

const Primary = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
`
const RightRow = styled.div``
const FirstRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3px;
`
const SecondRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3px;
`
const Text = styled.div`
  height: 5px;
  width: 100%;
  border-radius: 1px;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 10px;
`
const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
const Center = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
const Right = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 18px;
`
const Separator = styled.div`
  height: 1px;
`
const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 2px;
  padding: 10px;
`
const Skeleton = styled.div`
  height: 16px;
  border-radius: 1px;
`
